export const McuFilms = `
Iron Man,May 2008,200805
The Incredible Hulk,June 2008,200806
Iron Man 2,May 2010,201005
Thor,May 2011,201105
Captain America: The First Avenger,July 2011,201107
The Avengers,May 2012,201205
Iron Man 3,May 2013,201305
Thor: The Dark World,November 2013,201311
Captain America: The Winter Soldier,April 2014,201404
Guardians of the Galaxy,August 2014,201408
Avengers: Age of Ultron,May 2015,201505
Ant-Man,July 2015,201507
Captain America: Civil War,May 2016,201605
Doctor Strange,November 2016,201611
Guardians of the Galaxy Vol. 2,May 2017,201705
Spider-Man: Homecoming,July 2017,201707
Thor: Ragnarok,November 2017,201711
Black Panther,February 2018,201802
Avengers: Infinity War,April 2018,201804
Ant-Man and the Wasp,July 2018,201807
Captain Marvel,March 2019,201903
Avengers: Endgame,April 2019,201904
Spider-Man: Far From Home,July 2019,201907
Black Widow,July 2021,202107
Shang-Chi and the Legend of the Ten Rings,September 2021,202109
Eternals,November 2021,202111
Spider-Man: No Way Home,December 2021,202112
Doctor Strange in the Multiverse of Madness,May 2022,202205
Thor: Love and Thunder,July 2022,202207
Black Panther: Wakanda Forever,November 2022,202211
Ant-Man and the Wasp: Quantumania,February 2023,202302
Guardians of the Galaxy Vol. 3,May 2023,202305
The Marvels,November 2023,202311
Deadpool & Wolverine,July 2024,202407
Captain America: Brave New World,February 2025,202502
Thunderbolts*,May 2025,202505
The Fantastic Four: First Steps,July 2025,202507
`;